import { useEffect } from "react";

export const useTextOverflow = (
  ref: React.RefObject<HTMLElement>,
  deps: any[] = []
) => {
  useEffect(() => {
    const el = ref.current;

    if (!el) return;

    const textWidth = el.scrollWidth;
    const containerWidth = el.clientWidth;

    if (textWidth <= containerWidth) return;

    const distance = textWidth - containerWidth;
    const speed = 50; 
    const duration = distance / speed;

    el.style.setProperty("--move", `${distance}px`);
    el.style.setProperty("--duration", `${duration}s`);
  }, deps);
};